import { useState, type ReactNode } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface BankAccountSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

const COMMON_ACCOUNTS = [
  "Checking Account",
  "Savings Account",
  "Business Checking",
  "Business Savings",
  "Credit Card",
];

export function BankAccountSelector({ value, onChange }: BankAccountSelectorProps): ReactNode {
  const [custom, setCustom] = useState(false);

  return (
    <div className="bank-account-selector">
      <label className="bank-account-label" htmlFor="bank-account">
        Which bank account is this statement from?
      </label>
      {!custom ? (
        <div className="bank-account-options">
          <select
            id="bank-account"
            value={value}
            onChange={(e) => {
              if (e.target.value === "__custom__") {
                setCustom(true);
                onChange("");
              } else {
                onChange(e.target.value);
              }
            }}
            className="bank-account-select"
          >
            <option value="">Select an account (optional)</option>
            {COMMON_ACCOUNTS.map((account) => (
              <option key={account} value={account}>
                {account}
              </option>
            ))}
            <option value="__custom__">Type a custom name...</option>
          </select>
        </div>
      ) : (
        <AnimatePresence>
          <motion.div
            className="bank-account-custom"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
          >
            <input
              id="bank-account"
              type="text"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              placeholder="Type account name..."
              className="bank-account-input"
              autoFocus
            />
            <button
              type="button"
              className="bank-account-back"
              onClick={() => {
                setCustom(false);
                onChange("");
              }}
            >
              Back to list
            </button>
          </motion.div>
        </AnimatePresence>
      )}
    </div>
  );
}
